import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { Button, Modal, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';

import { history, RoutePaths } from 'helpers';

interface TransactionFoundWarningModalProps {
    isOpen: boolean;
    onClose: Function;
}

const useStyles = makeStyles(() => {
    return {
        modal: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        root: {
            width: '600px',
            padding: '56px',
            height: '400px',
            margin: 'auto',
            display: 'flex',
            flexDirection: 'column',
            position: 'absolute',

            borderRadius: '10px',
            border: '2px solid #009ADE',
        },
        header: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        body: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            padding: '20px 0',
        },
        button: {
            width: '250px',
        },
        footer: {
            display: 'flex',
            gap: '100px',
            justifyContent: 'center',
        },
    };
});

const TransactionFoundWarningModal: FC<TransactionFoundWarningModalProps> = ({
    isOpen,
    onClose,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Modal className={classes.modal} open={isOpen}>
            <Paper className={classes.root}>
                <div className={classes.header}>
                    <Typography variant='h3'>
                        {t('Transactions found')}
                    </Typography>
                </div>
                <div className={classes.body}>
                    <Typography
                        align='center'
                        variant='h4'
                        style={{ fontWeight: 'normal' }}
                    >
                        {t(
                            'Before re-registering the Kiosk, please perform a cash collection first'
                        )}
                    </Typography>
                </div>

                <div className={classes.footer}>
                    <Button
                        className={classes.button}
                        variant='secondary'
                        onClick={() => {
                            onClose();
                        }}
                    >
                        <Typography variant='button'>{t('Close')}</Typography>
                    </Button>
                    <Button
                        className={classes.button}
                        variant='primary'
                        onClick={() => {
                            history.push({
                                pathname: RoutePaths.CashCollection,
                                search: history.location.search,
                            });
                        }}
                    >
                        <Typography variant='button'>
                            {t('Cash Collection')}
                        </Typography>
                    </Button>
                </div>
            </Paper>
        </Modal>
    );
};

export default observer(TransactionFoundWarningModal);
